export function getCuentaBanco(state) {
  return state.cuentaBanco;
}



